<template>
  <div class="alert-viewer fixed bottom-0 z-20 mb-2 w-full">
    <PAlert
      v-if="currentAlert"
      :type="currentAlert.type"
      :title="currentAlert.title"
      :description="currentAlert.body"
      :actions="
        currentAlert.action
          ? [{ label: currentAlert.action.label, onClick: onAlertAction }]
          : undefined
      "
      class="mx-1 md:mx-2"
      size="lg"
      close
      @close="onAlertClose"
    />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia"
import { useAlertStore } from "@/store/alert.store"
import PAlert from "@/components/elements/PAlert.vue"

const alertStore = useAlertStore()
const { currentAlert } = storeToRefs(alertStore)

function onAlertClose() {
  alertStore.displayNextAlert()
}

async function onAlertAction() {
  const action = currentAlert.value?.action
  if (!action) return

  await action.handler()
  onAlertClose()
}
</script>

<style scoped></style>
